import { api } from '../../services/api'
import { showError, showSuccess } from '../misc/misc.actions'

export const postAccounts = (householdId, payload) => {
	return (dispatch) => {
		dispatch({ type: 'CREATE_ACCOUNTS', payload })
		return api
			.post(`/clients/${householdId}/accounts`, payload)
			.then((response) => {
				let { accounts } = response.data
				dispatch(showSuccess('Accounts updated successfully.'))
				dispatch({ type: 'SET_ACCOUNTS', payload: accounts })
				dispatch({ type: 'UPDATE_HOUSEHOLD_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				let error = e

				dispatch(showError('Error creating account.'))


				dispatch({
					type: 'CREATE_ACCOUNTS_FAIL',
					payload:
						error && error.data && error.data.message
							? error.data.message
							: null
				})
			})
	}
}

export const uploadIdInfoFile = (accountId, key, payload) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_ACCOUNTS' })
		return api
			.post(`/accounts/${accountId}/${key}/file`, payload)
			.then((response) => {
				let account = response.data

				let household = {
					_id: account.household,
					accounts: [account]
				}

				dispatch({ type: 'UPDATE_ACCOUNTS_SUCCESS', payload: account })
				dispatch({ type: 'UPDATE_HOUSEHOLD_SUCCESS', payload: household })
			})
			.catch((e) => {
				dispatch({ type: 'UPDATE_ACCOUNTS_FAIL' })
			})
	}
}

export const activate = (accountId) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_ACCOUNTS' })
		return api
			.post(`/accounts/${accountId}/activate`)
			.then((response) => {
				let account = response.data

				let household = {
					_id: account.household,
					accounts: [account]
				}

				dispatch({ type: 'UPDATE_ACCOUNTS_SUCCESS', payload: account })
				dispatch({ type: 'UPDATE_HOUSEHOLD_SUCCESS', payload: household })
			})
			.catch((e) => {
				dispatch({ type: 'UPDATE_ACCOUNTS_FAIL' })
			})
	}
}

export const deactivate = (accountId) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_ACCOUNTS' })
		return api
			.post(`/accounts/${accountId}/deactivate`)
			.then((response) => {
				let account = response.data

				let household = {
					_id: account.household,
					accounts: [account]
				}

				dispatch({ type: 'UPDATE_ACCOUNTS_SUCCESS', payload: account })
				dispatch({ type: 'UPDATE_HOUSEHOLD_SUCCESS', payload: household })
			})
			.catch((e) => {
				dispatch({ type: 'UPDATE_ACCOUNTS_FAIL' })
			})
	}
}
